const settings = {
  flags: {
    enableDonorSwapping: false,
  },
}

export default settings
